import React from "react";
import Slider from 'rc-slider';
import { withLocalize } from "react-localize-redux";
import { connect } from "formik";

import "../../searchSections/slider.scss";
import "../../../css/marketing-list/rc-slider.min.css";

const colors = ["#c32127", "#c32127", "#DA3925", "#f05123", "#F79215", "#fed206", "#CFCF21", "#a0cc3b", "#6AC36B", "#33ba9a", "#33ba9a"]

class RelationsSearchParametersSlider extends React.Component {
    render() {
        return (
            <Slider
                className="subject-rating-range"
                marks={this.props.marks}
                min={this.props.min}
                max={this.props.max}
                value={this.props.value}
                onChange={(value) => this.onChange(value)}
            />
        )
    }

    componentDidMount() {
        // this.calculateGradient(this.props.formik.values.cribisIndexMin, this.props.formik.values.cribisIndexMax)
    }

    onChange(value) {
        this.props.onChange(value)
        // this.calculateGradient(-values[0], -values[1]);
    }

    calculateGradient(min, max, length) {
        const gray = "#dedede";
        if (max === -0) {
            max = 0;
        }
        let background = "";
        if (max === min) {
            background = gray
        }
        else {
            let gradientColors = [];
            // for (let i = 10; i >= 0; i--) {
            for (let i = 0; i < 11; i++) {
                // if (i < max || i > min) {
                if (i < min || i > max) {
                    gradientColors.push(gray)
                }
                else {
                    gradientColors.push(colors[i]);
                }
            }

            let tmpBackground = gradientColors.map((x, i, arr) => {
                if (x === gray && arr[i + 1] !== gray) {
                    return `${gray} ${i * 10 + 10}%`;
                }
                if (x !== gray && arr[i + 1] === gray) {
                    return `${x} ${i * 10}%, ${gray} ${i * 10}%`;
                }
                return `${x} ${i * 10}%`;

            });
            background = `linear-gradient(90deg, ${tmpBackground}`;
        }
        document.querySelector(".rc-slider-track-1").style.background = background;
    }
}


export default withLocalize(connect(RelationsSearchParametersSlider));